import { useQuery } from "@tanstack/react-query";
import CollaboratorsService from "../services/api/collaborators/Collaborators.service";
import {
  COLLABORATORS_PAGE_SIZE,
  RefreshReactQuery,
} from "../constants/AppConstants";
import { FilterProps } from "../types/AppTypes";
import FiltersService from "../services/api/filters/filters.service";
import { useNotification } from "./notification.hook";
import { useEffect } from "react";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

interface useCollaboratorsProps {
  paginationCollaborators: number;
  queryParams: FilterProps[];
  enabled?: boolean;
}

export const useCollaborators = ({
  paginationCollaborators,
  queryParams,
  enabled = true,
}: useCollaboratorsProps) => {
  const { notification } = useNotification();
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ["get-collaborators", queryParams, paginationCollaborators],
    queryFn: ({ signal }) =>
      CollaboratorsService.list(
        COLLABORATORS_PAGE_SIZE,
        paginationCollaborators,
        queryParams,
        signal,
      ),
    staleTime: RefreshReactQuery.MODERATE,
    enabled,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading, isFetching };
};

export const useCollaboratorsFilters = (enabled?: boolean) => {
  const { notification } = useNotification();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["get-filters-collaborators"],
    queryFn: () => FiltersService.listForCollaborators(),
    staleTime: RefreshReactQuery.HIGH,
    enabled,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading };
};
